// src/components/DemoModal.tsx

import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { X } from "lucide-react";

import "../styles/DemoModal.css";

interface DemoModalProps {
  open: boolean;
  onClose: () => void;
}

const DemoModal = ({
  open,
  onClose,
}: DemoModalProps) => {

  const formRef = useRef<HTMLFormElement>(null);

  const [loading, setLoading] = useState(false);

  const sendEmail = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {

    e.preventDefault();

    if (!formRef.current) return;

    try {

      setLoading(true);

      await emailjs.sendForm(
        "service_mwmvtag",
        "template_k0ppbek",  // Template_ID
        formRef.current,
        "lxfaeMFhfzb8lG8L4" //Public_Key
      );

      alert("Demo request submitted!");

      formRef.current.reset();

      onClose();

    } catch (error) {

      console.error(error);

      alert("Failed to send request.");

    } finally {

      setLoading(false);

    }
  };

  if (!open) return null;

  return (

    <div className="demo-overlay">

      <div className="demo-modal">

        {/* CLOSE */}

        <button
          className="demo-close"
          onClick={onClose}
        >
          <X size={22} />
        </button>

        {/* HEADER */}

        <div className="demo-header">

          <span>BOOK A DEMO</span>

          <h2>
            Start Your
            Smart Nutrition Journey
          </h2>

          <p>
            Tell us about your business
            and our team will contact you.
          </p>

        </div>

        {/* FORM */}

        <form
          ref={formRef}
          className="demo-form"
          onSubmit={sendEmail}
        >

          <input
            type="text"
            name="user_name"
            placeholder="Your Name"
            required
          />

          <input
            type="text"
            name="organization"
            placeholder="Organization Name"
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            required
          />

          <select
            name="business_type"
            required
          >

            <option value="">
              Select Business Type
            </option>

            <option value="Gym">
              Gym
            </option>

            <option value="Corporate">
              Corporate
            </option>

            <option value="University">
              University
            </option>

            <option value="Others">
              Others
            </option>

          </select>

          <input
            type="text"
            name="city"
            placeholder="City"
            required
          />

          <input
            type="text"
            name="county"
            placeholder="County"
            required
          />

          <button type="submit">

            {loading
              ? "Submitting..."
              : "Submit Request"}

          </button>

        </form>

      </div>

    </div>

  );
};

export default DemoModal;